/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import CommonAlertsStrip from "../../../../components/_utils/CommonAlertsStrip/index.jsx";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import TopNavLargeButton from "../../../../components/_utils/CommonButtons/TopNavLargeButton/index.jsx";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import CommonQuickActionButtons from "../../../../components/_utils/CommonQuickActionButtons/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index.js";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import AdditionalRecipient from "../../../../components/AdditionalRecipient/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import useServiceChecker from "../../../../components/ServiceChecker/index.jsx";
import ScheduleInternalTransactionViewAllPopup from "../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionViewallpopup/index.jsx";
import IFSCDetails from "../../../../containers/Settings/IFSCDetails";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import {
  addInternalAccountLabel,
  approveInternalAccount,
  internalAccountDetailsById,
  rejectInternalAccount,
  removeInternalAccountLabel,
  resetEditInternalAccount,
  updateInternalAccount,
} from "../../../../redux/features/accounts/internalAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { ownerAccountsViewAll } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { internalTransactionsReject } from "../../../../redux/features/transactions/internalTransactions/index.js";
import { scheduledInternalReject } from "../../../../redux/features/transactions/scheduleInternalTransactions/index.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider.js";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import globalText from "../../../../utils/globalText.js";
import { linkIdentifier } from "../../../../utils/linkIdentifier.js";
import GSTVerification from "../../../Settings/GSTDetails/index.jsx";
import PanVerification from "../../../Settings/PanVerification/index.jsx";
import InternalTransactionViewAll from "../../../Transactions/InternalTransactions/InternalTransactionViewAll/index.jsx";
import InternalAccountViewAll from "../InternalAccountViewAll/index.jsx";

const InternalAccountDetails = (payload) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ensureAll] = useServiceChecker();
  const hasFetchedOwner = useRef(false);
  const labelActionDispatchedRef = useRef(false);
  const [labels, setLabels] = useState([]);
  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [loading, setLoading] = useState(true);
  const [deniedId, setDeniedId] = useState(null);
  const [detailTab, setDetailTab] = useState(true);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [remAccount, setRemAccount] = useState("");
  const [recipients, setRecipients] = useState([]);
  const [errorStrip, setErrorStrip] = useState("");
  const [editPopUp, setEditPopUp] = useState(false);
  const [viewIntData, setViewIntData] = useState([]);
  const [declineType, setdeclineType] = useState("");
  const [clickedBtn, setClickedBtn] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [activeType, setActiveType] = useState("pan");
  const [labelDetails, setLabelDetails] = useState([]);
  const [declineReason, setDeclineReason] = useState("");
  const [associateType, setAssociateType] = useState("");
  const [isAlertPopup, setIsAlertPopup] = useState(false);
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [owneraccountId, setOwnerAccountId] = useState("");
  const [rejectFlowType, setRejectFlowType] = useState("");
  const [animationClass, setAnimationClass] = useState("");
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [openTxnHistory, setOpenTxnHistory] = useState(false);
  const [labelDetailTab, setLabelDetailTab] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [showDeclinePopup, setShowDeclinePopup] = useState(false);
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [additionalRecipient, setAdditionalRecipicent] = useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [openInternalAssociate, setOpenInternalAssociate] = useState(false);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    category_ids: "",
    id: "",
    pan: "",
    bank_account_holder_full_name: "",
  });
  const [index, setIndex] = useState(
    detailTab
      ? GlobalConfiguration?.lengthCheckZero
      : labelDetailTab
        ? GlobalConfiguration?.lengthCheckOne
        : additionalRecipient
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const services = useSelector((state) => state.refreshToken.services);
  const {
    internalAccountDetailsData,
    internalAccountDetailsLoading,
    rejectInternalAccountLoading,
  } = useSelector((state) => state.internalAccount);

  const {
    internalTransactionsViewAllData,
    internalTransactionsViewAllLoading,
  } = useSelector((state) => state?.internalTransactions);

  const { scheduledInternalViewData, scheduledInternalViewLoading } =
    useSelector((state) => state?.scheduleInternalTransactions);

  const internalAccount = internalAccountDetailsData?.internal_accounts?.[0];

  const detailsAssoicatedAccount =
    internalAccount?.associate_bank === "Y" ||
    internalAccount?.associate_pan === "Y";

  const isArchived = internalAccount?.approval_status === "archived";
  const isBlocked = internalAccount?.approval_status === "blocked";

  const pendingTxn = internalAccount?.pending_internal_transactions;
  const pendingScheduleTxn =
    internalAccount?.pending_scheduled_internal_transactions;

  const isInternalAccountDetailModal =
    payload?.type === "bene_account_detail_modal";

  const resolvedAccountId = isInternalAccountDetailModal
    ? payload?.bene_account_id
    : id;

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useLayoutEffect(() => {
    setLoading(true);
  }, [resolvedAccountId]);

  const handleInputChange = (event) => {
    const value = event.target.value?.replace(/\s+/g, " ").trimStart() || "";

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    if (sanitizedValue.length <= GlobalConfiguration.inputMaxLength) {
      setDeclineReason(sanitizedValue);
    }
  };

  useEffect(() => {
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
      return;
    }

    const bankAccNo = internalAccount?.bank_acc_no;
    const panNo = internalAccount?.pan_no;
    const ifscCode = internalAccount?.ifsc_code;

    if (!bankAccNo || !panNo || !ifscCode) return;

    if (hasFetchedOwner.current) return;
    hasFetchedOwner.current = true;

    const fetchOwnerID = async () => {
      if (ensureAll(["VAccount"]).status) {
        const data = await dispatch(
          ownerAccountsViewAll({
            bank_account_no: bankAccNo,
            pan: panNo,
            ifsc: ifscCode,
          }),
        );
        setOwnerAccountId(data?.payload?.owner_accounts?.[0]?.id);
      }
    };

    fetchOwnerID();
    setViewIntData(internalAccountDetailsData?.internal_accounts);
  }, [
    internalAccountDetailsData,
    internalAccount?.bank_acc_no,
    internalAccount?.pan_no,
    internalAccount?.ifsc_code,
  ]);
  useEffect(() => {
    if (
      internalAccountDetailsData &&
      internalAccountDetailsData.internal_accounts &&
      internalAccountDetailsData.internal_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const {
        bank_name,
        bank_acc_no,
        category_ids,
        ifsc_code,
        id,
        pan_no,
        name,
      } = internalAccount;
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category_ids: category_ids?.filter((fil) => {
          return fil.category_name === "Internal";
        })[0],
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [internalAccountDetailsData]);

  const toggleDetails = () => {
    setDetailTab(true);
    setLabelDetailTab(false);
    setAdditionalRecipicent(false);
  };

  const toggleLabelDetails = () => {
    setLabelDetailTab(true);
    setDetailTab(false);
    setAdditionalRecipicent(false);
  };
  const toggleAdditionalRecipicent = () => {
    setAdditionalRecipicent(true);
    setLabelDetailTab(false);
    setDetailTab(false);
  };
  const handleModalClose = () => {
    setIsEditModalOpen(false);
  };
  const handleApprovalDetails = async (id) => {
    setShowLoader(true);

    UniversalRefreshToast("approvalaccountsRefresh");

    let response = await dispatch(approveInternalAccount({ id }));

    toast.dismiss();
    if (
      response?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "IAAccount",
        },
      });
      return;
    }
    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      setShowLoader(false);
      let errorMsg = "";
      if (response?.payload === undefined) {
        errorMsg = "An error occured while taking action on this account";
      } else if (response?.payload?.errors?.internal_account?.[0]) {
        errorMsg = response.payload.errors.internal_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        errorMsg = response.payload.errors.bank_account_number[0];
      } else {
        errorMsg = "An unknown error occurred.";
      }
      if (errorMsg === "Internal account already approved") {
        await dispatch(internalAccountDetailsById({ id: resolvedAccountId }));
      } else {
      }

      const errMsg = errorMsg;
      const updatedAccounts =
        response?.payload?.internal_accounts ||
        internalAccountDetailsData?.internal_accounts ||
        [];
      if (updatedAccounts.length === GlobalConfiguration.lengthCheckZero) {
        setViewIntData([
          {
            ...(internalAccount || {}),
            errorMsg: errMsg,
          },
        ]);
      } else {
        if (!updatedAccounts[GlobalConfiguration.lengthCheckZero].errorMsg)
          updatedAccounts[GlobalConfiguration.lengthCheckZero].errorMsg =
            errMsg;
        setViewIntData(updatedAccounts);
      }
      toast.dismiss();
      CommonToast({
        text: errorMsg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } else {
      setViewIntData(response?.payload?.internal_accounts || []);
      setShowLoader(false);

      const successMessage = "Internal account approved successfully.";
      toast.dismiss();
      CommonToast({
        text: successMessage,
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      if (isInternalAccountDetailModal) {
        setTimeout(() => {
          payload?.closeBeneAccountDetailModal();
          if (
            window.location.pathname !==
            "/internal_transaction_dashboard/create_internal_transaction"
          ) {
            window.location.reload();
          }
        }, IntervalConfiguration.intervalExtraLarger);
        setTimeout(() => {
          if (
            window.location.pathname !==
            "/internal_transaction_dashboard/create_internal_transaction"
          ) {
            navigate("/internal_account_dashboard/internal_account_approval");
          }
        }, IntervalConfiguration.intervalPopup);
      }
    }
  };

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);

  const handleDeclinedDetials = (id) => {
    setClickedBtn("reject");
    setShowDeclinePopup(true);
    setDeniedId(id);
    setRejectFlowType("rejectAccount");
  };

  const createIntTransaction = () => {
    if (
      services?.find(
        (service) => service === "CInternalTxn" || service === "Admin",
      ) !== undefined
    ) {
      navigate("/internal_transaction_dashboard/create_internal_transaction", {
        state: currentAccountDetails,
      });
    } else if (
      services?.find(
        (service) => service === "CInternalTxn" || service === "Admin",
      ) !== undefined &&
      currentAccountDetails?.category_ids?.length <=
        GlobalConfiguration?.lengthCheckZero
    ) {
      CommonToast({
        text: "Category can't be blank",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
  };

  const openAssociatedAccountsFound = () => {
    setRemPan(internalAccount?.pan_no);
    setOpenInternalAssociate(true);
  };

  const openTransactionHistory = () => {
    setOpenTxnHistory(true);
  };

  const handleClosePopup = () => {
    setShowDeclinePopup(false);
    if (payload?.type === "scheduleAcc") {
      setShowScheduleTxnPopup(false);
    }
    setRejectFlowType("");
    setShowLoader(false);
  };

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${payload.bene_account_id}`,
    });
  };

  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");

  const isServiceMissing = !(hasALabel && hasRLabel);

  const handleRejectScheduleInternalTxn = async () => {
    setShowLoader(true);

    let id2 =
      !scheduledInternalViewLoading &&
      scheduledInternalViewData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? scheduledInternalViewData?.transactions.map((data) => data?.txn_id)
        : [];

    if (id2.length === GlobalConfiguration.lengthCheckZero) {
      setShowLoader(false);
      return;
    }

    try {
      const data2 = await dispatch(
        scheduledInternalReject({
          id: id2,

          reason: declineReason,
        }),
      );

      UniversalRefreshToast("Rejecting transaction");

      if (data2?.payload?.status === false) {
        const errorMsg2 =
          data2?.payload?.errors?.user_unauthorized?.[
            GlobalConfiguration.lengthCheckZero
          ] ||
          (Array.isArray(data2?.payload?.errors?.base) &&
          Array.isArray(
            data2?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
              ?.errors,
          )
            ? data2.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                .errors[GlobalConfiguration.lengthCheckZero]
            : data2?.payload?.errors?.base?.[
                GlobalConfiguration.lengthCheckZero
              ]) ||
          "Unknown error occurred";

        CommonToast({
          text: errorMsg2,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);

        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });

        const currentAccountId = deniedId || resolvedAccountId;

        await dispatch(internalAccountDetailsById({ id: currentAccountId }));

        if (rejectFlowType === "rejectAccount") {
          await handleInternalAccountreject(currentAccountId, declineReason);
        } else if (rejectFlowType === "rejectSchedulesOnly") {
        }
      }
    } catch (error) {
      console.error("Error rejecting schedules:", error);
      CommonToast({
        text: "Something went wrong while rejecting schedules",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setShowLoader(false);
      setDeclineReason("");
      setAssociateType("");
    }
  };

  const handleInternalAccountreject = async (id, rejectionReason) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (
      !rejectInternalAccountLoading ||
      rejectInternalAccountLoading === null
    ) {
      const data = await dispatch(
        rejectInternalAccount({
          id,
          rejection_reason: rejectionReason,
        }),
      );

      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "IAAccount",
          },
        });
        return;
      }

      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false) {
        let errorMsg = "";

        if (
          data?.payload?.errors?.internal_account?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          errorMsg =
            data?.payload?.errors?.internal_account?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (
          data?.payload?.errors?.bank_account_number?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          errorMsg =
            data?.payload?.errors?.bank_account_number?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (data?.payload?.errors?.beneficiary_account) {
          errorMsg =
            data?.payload?.errors?.beneficiary_account?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else {
          errorMsg = "An unknown error occurred.";
        }

        setErrorStrip(errorMsg);
        setShowDeclinePopup(false);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);

        const errMsg = errorMsg;

        const updatedAccounts =
          data?.payload?.internal_accounts ||
          internalAccountDetailsData?.internal_accounts ||
          [];

        if (updatedAccounts.length === GlobalConfiguration.lengthCheckZero) {
          setViewIntData([
            {
              ...(internalAccount || {}),
              errorMsg: errMsg,
            },
          ]);
        } else {
          const updatedData = updatedAccounts.map((account, index) =>
            index === GlobalConfiguration.lengthCheckZero && !account?.errorMsg
              ? {
                  ...account,
                  errorMsg: errMsg,
                }
              : account,
          );

          setViewIntData(updatedData);
        }

        toast.dismiss();

        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);

        if (data?.payload?.status === true) {
          toast.dismiss();

          CommonToast({
            text: "Account rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }

        await dispatch(
          internalAccountDetailsById({
            id: resolvedAccountId,
          }),
        );

        setShowDeclinePopup(false);

        if (isInternalAccountDetailModal) {
          await new Promise((resolve) => {
            setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
          });

          payload?.closeBeneAccountDetailModal?.();
          await payload?.onAccountUpdated?.();
        }
      }
    }
  };

  const handleClick = () => {
    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setShowLabelsPopup(true);
    }
  };

  async function fetchData() {
    if (internalAccountDetailsLoading) setLoading(true);
    try {
      let response;
      if (isInternalAccountDetailModal) {
        response = await dispatch(
          internalAccountDetailsById({ id: payload?.bene_account_id }),
        );
        setLabelDetails(response?.payload?.internal_accounts[0]?.labels || []);
        setShowAdditionalRecipient(
          response?.payload?.internal_accounts?.[0]?.recipient_email || [],
        );
        setAdditionalChip(
          response?.payload?.internal_accounts?.[0]?.recipient_email || [],
        );
      } else {
        const response = await dispatch(internalAccountDetailsById({ id }));
        setLabelDetails(response?.payload?.internal_accounts[0]?.labels || []);
        setShowAdditionalRecipient(
          response?.payload?.internal_accounts?.[0]?.recipient_email || [],
        );
      }

      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    } catch (error) {
      console.error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  }

  const finalRecipients = [...new Set([...recipients, ...additionalChip])];

  const handleConfirm = async () => {
    if (recipientButtonDisabled) return;
    const recipientString = [...recipients, ...additionalChip].join(",");
    let response = await dispatch(
      updateInternalAccount({
        id: id,
        recipient_email: recipientString,
        navigate,
      }),
    );
    if (response?.payload?.status) {
      setShowAdditionalSection(false);
      await fetchData();
      setRecipients([]);
    } else {
      setShowAdditionalSection(false);
    }
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message;
    }
    if (e?.message) return e.message;
    return;
  };

  const handleAssignLabelsProp = async (labelsToAssign, recordIdsFromPopup) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const accId = internalAccount?.id;
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(accId);
    const res = await dispatch(
      addInternalAccountLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addInternalAccountLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addInternalAccountLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (addInternalAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (
    labelsToUnassign,
    recordIdsFromPopup,
  ) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const accId = internalAccount?.id;
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(accId);
    const res = await dispatch(
      removeInternalAccountLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeInternalAccountLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeInternalAccountLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (removeInternalAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  let approvalEntry = [
    {
      heading: "Created by",
      content: internalAccount?.created_by_name || "Not given",
      type: "text",
    },
    {
      heading: "Created on",
      content: internalAccount?.created_on
        ? formatDateViewAll(internalAccount?.created_on, true, false)
        : "Not given",
      type: "text",
    },
  ];

  if (isBlocked) {
    approvalEntry.push(
      {
        heading: "Blocked by",
        content: internalAccount?.blocked_by_name || "Not given",
        type: "text",
      },
      {
        heading: "Blocked on",
        content: internalAccount?.blocked_on
          ? formatDateViewAll(internalAccount.blocked_on)
          : "Not given",
        type: "text",
      },
    );
  } else if (internalAccount?.approval_status === "rejected") {
    approvalEntry.push(
      {
        heading: "Rejected by",
        content: internalAccount?.rejected_by_name || "Not given",
        type: "text",
      },
      {
        heading: "Rejected on",
        content: internalAccount?.rejected_on
          ? formatDateViewAll(internalAccount.rejected_on, true, false)
          : "Not given",
        type: "text",
      },
      {
        heading: "Rejected reason",
        content: internalAccount?.rejection_reason || "Not given",
        type: "text",
      },
    );
  } else if (internalAccount?.approval_status === "approved") {
    approvalEntry.push(
      {
        heading: "Approved by",
        content: internalAccount?.approved_by_name || "Not given",
        type: "text",
      },
      {
        heading: "Approved on",
        content: internalAccount?.approved_on
          ? formatDateViewAll(internalAccount.approved_on, true, false)
          : "Not given",
        type: "text",
      },
    );
  }

  function handleChipClick(id) {
    if (selectedChipIndex === id) {
      setSelectedChipIndex(null);
    } else {
      setSelectedChipIndex(id);
    }
  }

  // const asAcc =
  //   viewInternalAccountDetailData?.internal_accounts[0]?.associate_bank ===
  //     "Y" ||
  //   viewInternalAccountDetailData?.internal_accounts[0]?.associate_pan === "Y";

  // const pendingTxn =
  //   viewInternalAccountDetailData?.internal_accounts[0]
  //     ?.pending_internal_transactions;

  // const pendingScheduleTxn =
  //   viewInternalAccountDetailData?.internal_accounts[0]
  //     ?.pending_scheduled_internal_transactions;

  const buildAlerts = () => [
    ...(detailsAssoicatedAccount !== undefined
      ? detailsAssoicatedAccount
        ? [
            {
              isDisabled: isInternalAccountDetailModal,
              isLoading: false,
              text: "Associated accounts are found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (isInternalAccountDetailModal) {
                  actionRestricted();
                } else {
                  openAssociatedAccountsFound(
                    internalAccount?.ifsc_code,
                    internalAccount?.bank_acc_no,
                    internalAccount?.pan_no,
                    internalAccount?.id,
                  );
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: true,
            text: "Checking associated account",
          },
        ]),

    ...(pendingTxn !== undefined
      ? pendingTxn === "Y" && internalAccount?.approval_status === "pending"
        ? [
            {
              isDisabled: isInternalAccountDetailModal,

              isLoading: false,
              text: "Pending transactions found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (isInternalAccountDetailModal) {
                  actionRestricted();
                } else {
                  setdeclineType("");
                  setShowRejectPopup(true);
                  setAssociateType("InternalTxn");
                  setRejectFlowType("rejectTransactionsOnly");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: true,
            text: "Checking pending transactions",
          },
        ]),

    ...(pendingScheduleTxn !== undefined
      ? pendingScheduleTxn === "Y" &&
        internalAccount?.approval_status === "pending"
        ? [
            {
              isDisabled: isInternalAccountDetailModal,

              isLoading: false,
              text: "Pending schedules found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (isInternalAccountDetailModal) {
                  actionRestricted();
                } else {
                  setShowScheduleTxnPopup(true);
                  setAssociateType("scheduleInternalTxn");
                  setRejectFlowType("rejectSchedulesOnly");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: true,
            text: "Checking schedule pending transactions",
          },
        ]),
  ];

  const chipsArray = [
    {
      text: "IFSC code",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckZero,
      disabled: true,
      hoverOption: "blue",
      bulletPoint: [
        "Contact the Xpentra administrator to change the IFSC detail.",
      ],
    },
    {
      text: "Name, Contact number, Email ID",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckOne,
      disabled: false,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Only the newly linked user will have access to this account after the change.",
      ],
      hoverOption: "blue",
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckOne),
    },
    {
      text: "PAN number, GST number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckThree,
      disabled: true,
      // bulletPoint: [
      //   "Account will be marked as pending and will require approval.",
      //   "Pending transactions associated with a pending account cannot be approved.",
      //   "If GST was entered during creation, it is required during editing.",
      // ],
      hoverOption: "blue",
    },
    {
      text: "Bank account number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFour,
      disabled: true,
      // bulletPoint: [
      //   "It will be created as a new beneficiary account and archive the old account.",
      //   "New beneficiary account will remain pending and will require approval.",
      //   "If GST was entered during creation, it is required during editing.",
      // ],
      hoverOption: "blue",
    },
  ];

  const handleApply = () => {
    dispatch(resetEditInternalAccount());

    if (selectedChipIndex === GlobalConfiguration?.lengthCheckOne) {
      navigate(
        `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/edit_account_details/${id}`,
      );
    }
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);

    const accountInfo = await dispatch(
      internalAccountDetailsById({ id: id || deniedId || resolvedAccountId }),
    );
    if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "Y" &&
      (accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y" ||
        accountInfo?.payload?.internal_accounts?.[0]
          ?.pending_scheduled_internal_transactions === "N")
    ) {
      setShowDeclinePopup(false);
      // setAssociateType("InternalTxn");
      setShowRejectPopup(true);
      setShowLoader(false);
    } else if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "N" &&
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y"
    ) {
      setShowDeclinePopup(false);
      // setDeclineReason("");
      setShowScheduleTxnPopup(true);
      setShowLoader(false);
    } else {
      handleInternalAccountreject(id, AccountIdData);
    }
  };

  const handleConfirmAlert = async () => {
    let openedSchedules = false;
    setShowLoader(true);

    try {
      const AccountIdData = declineReason;
      let allTxnId = [];

      allTxnId =
        !internalTransactionsViewAllLoading &&
        internalTransactionsViewAllData?.transactions?.length >
          GlobalConfiguration.lengthCheckZero
          ? internalTransactionsViewAllData?.transactions.map(
              (data) => data?.txn_id,
            )
          : [];

      UniversalRefreshToast("Rejecting transaction");

      let data = null;

      if (allTxnId.length > GlobalConfiguration.lengthCheckZero) {
        data = await dispatch(
          internalTransactionsReject({
            id: allTxnId,
            rejection_reason: AccountIdData,
          }),
        );
      }

      if (data?.payload?.status === false) {
        setShowRejectPopup(false);
        const errorMsg = data?.payload?.errors?.user_unauthorized
          ? data?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data?.payload?.errors?.base) &&
              Array.isArray(data?.payload?.errors?.base[0]?.errors)
            ? data.payload.errors.base[0].errors[0]
            : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        return;
      }

      if (
        data?.payload?.status === true ||
        allTxnId.length === GlobalConfiguration.lengthCheckZero
      ) {
        setShowRejectPopup(false);
        setShowDeclinePopup(false);

        toast.dismiss();
        CommonToast({
          text: "Transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });

        const currentAccountId = deniedId || resolvedAccountId;

        const refreshed = await dispatch(
          internalAccountDetailsById({ id: currentAccountId }),
        );

        const pendingScheduleFlag =
          refreshed?.payload?.internal_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.pending_scheduled_internal_transactions;

        if (rejectFlowType === "rejectAccount") {
          if (pendingScheduleFlag === "Y") {
            openedSchedules = true;
            setAssociateType("rejectAccount");
            setShowScheduleTxnPopup(true);
          } else {
            await handleInternalAccountreject(
              refreshed?.payload?.internal_accounts?.[
                GlobalConfiguration.lengthCheckZero
              ]?.id || currentAccountId,
              declineReason,
            );
          }
        } else if (rejectFlowType === "rejectTransactionsOnly") {
          await dispatch(internalAccountDetailsById({ id: currentAccountId }));
        }
      } else if (data?.payload === undefined) {
        setShowRejectPopup(false);
        CommonToast({
          text: "An error occurred while taking action on this account",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      console.error(error);
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setShowLoader(false);
      if (associateType === "InternalTxn" && !openedSchedules) {
        setDeclineReason("");
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        let response;
        if (isInternalAccountDetailModal) {
          response = await dispatch(
            internalAccountDetailsById({ id: payload?.bene_account_id }),
          );
        } else {
          response = await dispatch(internalAccountDetailsById({ id }));
        }

        if (
          !response?.payload ||
          response?.error?.status === errorcode.errorNotFound ||
          response?.error?.status === errorcode.errorUnAuthorized
        ) {
          navigate("/*");
          return;
        }
        setViewIntData(response?.payload?.internal_accounts);
        const account =
          response?.payload?.internal_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ] || {};

        setLabelDetails(account?.labels || []);
        setShowAdditionalRecipient(account?.recipient_email || []);
      } catch (error) {
        console.error("Failed to load the account details", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [payload?.bene_account_id, id, dispatch]);

  useEffect(() => {
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
      return;
    }

    const bankAccNo = internalAccount?.bank_acc_no;
    const panNo = internalAccount?.pan_no;
    const ifscCode = internalAccount?.ifsc_code;

    if (!bankAccNo || !panNo || !ifscCode) return;

    const fetchOwnerID = async () => {
      if (ensureAll(["VAccount"]).status) {
        hasFetchedOwner.current = true;
        const data = await dispatch(
          ownerAccountsViewAll({
            bank_account_no: bankAccNo,
            pan: panNo,
            ifsc: ifscCode,
          }),
        );
        setOwnerAccountId(
          data?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero]
            ?.id,
        );
      }
    };

    if (!hasFetchedOwner.current) {
      fetchOwnerID();
    }
    setViewIntData(internalAccountDetailsData?.internal_accounts);
  }, [
    internalAccountDetailsData,
    internalAccount?.bank_acc_no,
    internalAccount?.pan_no,
    internalAccount?.ifsc_code,
    services,
  ]);

  useEffect(() => {
    if (
      internalAccountDetailsData &&
      internalAccountDetailsData.internal_accounts &&
      internalAccountDetailsData.internal_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const {
        bank_name,
        bank_acc_no,
        category_ids,
        ifsc_code,
        id,
        pan_no,
        name,
      } =
        internalAccountDetailsData.internal_accounts[
          GlobalConfiguration.lengthCheckZero
        ];
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category_ids: category_ids?.filter((fil) => {
          return fil.category_name === "Internal";
        })[0],
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [internalAccountDetailsData]);

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("internalAccountLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [internalAccount?.labels]);

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);

  const hasAccess =
    services?.includes("AInternalTxn") || services?.includes("Admin");

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };
  useEffect(() => {
    setIndex(GlobalConfiguration?.lengthCheckZero);
    // setShowCategories(false);
    setLabelDetailTab(false);
    setAdditionalRecipicent(false);
    setDetailTab(true);
  }, [id]);
  return (
    <>
      <>{RestrictedActionPopup}</>
      {isAlertPopup && (
        <div className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext={globalText?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
            btnOneText={globalText?.STAY}
            btnOneHandleFunction={() => setIsAlertPopup(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoHandleFunction={() => {
              createIntTransaction();
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {editPopUp && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            isalert={true}
            alertImage={ICONS?.ERROR_WITH_WHITE_CIRCLE}
            btnOneHandleFunction={() => {
              setEditPopUp(false);
              setSelectedChipIndex(null);
            }}
            headerTitle="Select the option to edit:"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            alertText="Since this is an internal account other features have been disabled"
            alertTextFont={"text-primary"}
            alertBackground="emphasis"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoInActiveVariantNeeded
            btnTwoHandleFunction={handleApply}
            btnTwoIsDisabled={selectedChipIndex === null}
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            defaultHeight={selectedChipIndex}
          />
        </div>
      )}

      {showDeclinePopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Reject account"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Minimum 10 characters required."
            inputPlaceholder="Reason"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (showLoader) return;
              handleInputChange(e);
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                setDeclineReason("");
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "scheduleInternalTxn") {
                handleRejectScheduleInternalTxn();
              } else if (associateType === "InternalTxn") {
                handleConfirmAlert();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoInActiveVariantNeeded
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            bulletPoints={[
              "New schedules and transactions cannot be created for this account.",
              "Before rejecting this account, reject all associated transactions and schedules.",
              "Users can edit the rejected account to update details.",
            ]}
          />
        </div>
      )}
      {openInternalAssociate && (
        <LargePopupRedirect
          headerTitle="Associated accounts"
          headersubtext="The accounts listed below are linked to the selected internal account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setOpenInternalAssociate(false);
            setRemPan("");
            setRemAccount("");
            setRemIFSC("");
            setActiveType("pan");
            setRejectFlowType("");
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          confirmbtnrequired={true}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <InternalAccountViewAll
            id={internalAccount?.id}
            typePanBank={"BeneAccPanBankSwitch"}
            typepop={"popup"}
            flow={"detailPage"}
            remPan={remPan}
            remAccount={remAccount}
            remIFSC={remIFSC}
            activeType={activeType}
            associateAccount={true}
            // searchPanText={searchPanText}
            currentAccountDetails={
              internalAccountDetailsData?.internal_accounts
            }
            setOpenBeneAssociate={(e) => {}}
            onCardNavigate={(redirectUrl) => {
              setLoading(true);
              setOpenInternalAssociate(false);
              navigate(redirectUrl);
              setRemPan("");
              setRemAccount("");
              setRemIFSC("");
            }}
            handleButtonClick={(account) => {
              setLoading(true);
              setOpenInternalAssociate(false);
              navigate(
                `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${account.id}`,
              );
              setRemPan("");
              setRemAccount("");
              setRemIFSC("");
            }}
          />
        </LargePopupRedirect>
      )}

      {showRejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-max bg-custom-backdrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Associated transactions found"
            headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setShowRejectPopup(false);
              setRejectFlowType("");
              setDeclineReason("");
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasAccess
                ? "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
                : "To reject the transactions, please contact the authorised person who has the feature to reject the transactions."
            }
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              const servicesReq = ["AInternalTxn"];

              if (servicesReq.some((service) => services.includes(service))) {
                if (associateType === "InternalTxn") {
                  if (
                    declineReason &&
                    declineReason.length >= GlobalConfiguration.panLength
                  ) {
                    handleConfirmAlert();
                  } else {
                    setShowDeclinePopup(true);
                  }
                } else {
                  handleConfirmAlert();
                }
              }

              if (!hasAccess) {
                navigate("/feature_not_assigned", {
                  state: { unavailableService: "AInternalTxn" },
                });
                return;
              }
            }}
            enabledBgColor={
              hasAccess ? "var(--negative-act)" : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={!hasAccess}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            {internalAccountDetailsData?.internal_accounts?.[
              GlobalConfiguration.lengthCheckZero
            ]?.id && (
              <InternalTransactionViewAll
                typepop={"RejectInternalAcc"}
                type={
                  declineType === "rejectedAccount"
                    ? "Internal_AccountApproval"
                    : "RejectInternalTxn"
                }
                internal_acc_id={internalAccount?.id}
                internal_acc_name={internalAccount?.name}
                bank_acc_no={internalAccount?.bank_acc_no}
                OwnerDetail={true}
                balanceType={"credit"}
                BeneAccId={internalAccount?.id}
                closeRejectAllTxn={() => setShowRejectPopup(false)}
                setShowLoader={setShowLoader}
                setSidebarState={(e) => {}}
                setFocus={(e) => {}}
              />
            )}
          </LargePopupRedirect>
        </div>
      )}

      {showScheduleTxnPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center  z-z-index-max bg-custom-backdrop bg-opacity-dark-opacity">
          {showScheduleTxnPopup && (
            <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center  z-z-index-max bg-custom-backdrop bg-opacity-dark-opacity">
              <ScheduleInternalTransactionViewAllPopup
                onClose={() => {
                  setShowScheduleTxnPopup(false);
                  setRejectFlowType("");
                  setDeclineReason("");
                }}
                headerTitle="Associated schedules found"
                headerSubtitle="The following schedules are linked and need to be rejected before rejecting this account."
                showFooter
                footerTitle="To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
                showFooterButton
                footerButtonText="Reject all"
                onFooterButtonClick={() => {
                  if (associateType === "scheduleInternalTxn") {
                    if (
                      declineReason &&
                      declineReason.length >= GlobalConfiguration.panLength
                    ) {
                      handleRejectScheduleInternalTxn();
                    } else {
                      setShowDeclinePopup(true);
                    }
                  } else {
                    handleRejectScheduleInternalTxn();
                  }
                }}
                contentProps={{
                  type: "scheduleInternalAcc",
                  txnHistorytype: "scheduleInternalAccApproval",
                  internal_account_id: internalAccount?.id,
                  internal_account_name: internalAccount?.name,
                  onClose: undefined,
                }}
              />
            </div>
          )}
        </div>
      )}

      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipient
            finalRecipients={finalRecipients}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirm}
            recipients={recipients}
            setRecipients={setRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}
      {isEditModalOpen && (
        <EditCommonPopup
          btnOneHandleFunction={handleModalClose}
          headerTitle="Select the option you would like to edit:lk"
          alertBackground="emphasis"
          chipsArray={chipsArray}
          btnOneText="Cancel"
          btnOneEnabledBgColor="var(--primary-bg)"
          btnOneEnabledTextColor="var(--text-primary)"
          btnOneHoverOption="white"
          btnOneOutLineColor="var(--text-primary)"
          btnTwoText="Edit"
          btnTwoHandleFunction={handleApply}
          btnTwoIsDisabled={
            selectedChipIndex === null ||
            selectedChipIndex === GlobalConfiguration.lengthCheckZero
          }
          btnTwoDisabledTextColor="var(--text-primary)"
          btnTwoEnabledBgColor="var(--text-primary)"
          btnTwoEnabledTextColor="var(--primary-bg)"
          btnTwoDisabledBgColor="var(--text-disabled)"
          btnTwoHoverOption="black"
          defaultHeight={selectedChipIndex}
        />
      )}
      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: internalAccount?.gstin_detail,
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={internalAccount?.gstin_detail}
            popup={true}
          />
        </LargePopupRedirect>
      )}
      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${internalAccount?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <IFSCDetails
              ifsc_code={internalAccount?.ifsc_code}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state: internalAccount?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={internalAccount?.pan_no}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={[internalAccount?.id].filter(Boolean)}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={[internalAccount].filter(Boolean)}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {openTxnHistory && (
        <LargePopupRedirect
          headerTitle={"Transaction history"}
          headersubtext={
            "All transactions related to the internal are listed below."
          }
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => setOpenTxnHistory(false)}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <InternalTransactionViewAll
            internal_account_id={internalAccount?.id}
            internal_acc_name={internalAccount?.name}
            txnHistorytype={"internalTxnHistory"}
            typepop={"internalAccTxnHistoryPopUp"}
            BeneAccId={id}
            onClose={() => setOpenTxnHistory(false)}
            setOpenTransHistory={setOpenTxnHistory}
            setLoading={setLoading}
            onCardNavigate={(redirectUrl) => {
              setOpenTxnHistory(false);
              navigate(redirectUrl);
            }}
          />
        </LargePopupRedirect>
      )}
      <div
        className={`z-z-index-overlay fixed w-full Qsmd:hidden flex items-start bg-primary-nav ${isInternalAccountDetailModal ? "hidden" : "block"}`}
      >
        <TopNavComponent
          isFormattingNotRequired={true}
          topNavHeader="Internal"
          topNavSubText="Account details"
        />
      </div>
      {!isInternalAccountDetailModal && (
        <div class="h-loader-lg Qsmd:h-navbar-breadcrumb-height bg-primary-card lg:bg-primary-nav w-width-full"></div>
      )}
      <div
        className={`${
          isInternalAccountDetailModal
            ? "overflow-hidden overflow-y-auto bg-primary-bg h-full"
            : editPopUp ||
                showGstPopup ||
                showPanPopup ||
                showIfscPopup ||
                showLabelsPopup ||
                showScheduleTxnPopup ||
                showDeclinePopup ||
                openTxnHistory ||
                openInternalAssociate ||
                showRejectPopup
              ? "flex flex-col overflow-y-hidden overflow-x-hidden"
              : "flex flex-col overflow-x-hidden"
        }`}
      >
        {loading && (
          <>
            <div className="flex justify-center items-center m-auto !h-full-height">
              <Loader />
            </div>
          </>
        )}
        {!loading && (
          <>
            <div className="h-auto bg-primary-nav hidden Qlg:block">
              <div
                className={`w-full max-w-tab-width-normal m-auto bg-primary-nav ${payload?.type !== "bene_account_detail_modal" ? "mt-var(--navbar-height) pt-var(--padding-xl)" : ""}`}
              >
                <div className="flex  border-b border-solid border-primary-bg justify-center">
                  <div className="w-width-full flex  py-padding-md">
                    <div className="Qmd:pl-padding-sm flex flex-col w-width-md gap-y-gap-xs whitespace-normal break-words justify-center">
                      <TitleSubtitlePair
                        subtitle="Account name"
                        title={internalAccount?.name?.trim()}
                        titleColor="text-primary"
                        variant="md"
                      />
                    </div>
                    <div className="border-r border-solid border-primary-bg"></div>
                    {viewIntData?.map((account) => (
                      <div className="flex flex-col w-width-md gap-y-gap-xs pl-padding-md justify-center">
                        <TitleSubtitlePair
                          subtitle="Account status"
                          variant="md"
                          titleColor={
                            account.approval_status === "approved"
                              ? "awaiting"
                              : account.approval_status === "pending" &&
                                  services?.includes("IAAccount")
                                ? "pending"
                                : account.approval_status === "pending"
                                  ? "pending"
                                  : account.approval_status === "rejected"
                                    ? "failed"
                                    : account.approval_status === "blocked"
                                      ? "failed"
                                      : account.approval_status === "archived"
                                        ? "abandoned"
                                        : ""
                          }
                          title={
                            account.approval_status === "approved"
                              ? "Approved"
                              : account.approval_status === "pending" &&
                                  services?.includes("IAAccount")
                                ? "Require approval"
                                : account.approval_status === "pending"
                                  ? "Pending"
                                  : account.approval_status === "rejected"
                                    ? "Rejected"
                                    : account.approval_status === "blocked"
                                      ? "Blocked"
                                      : account.approval_status === "archived"
                                        ? "Archived"
                                        : ""
                          }
                          isBold={true}
                        />
                      </div>
                    ))}
                  </div>
                  <div
                    className={`${
                      isInternalAccountDetailModal
                        ? "flex bg-primary-nav-act opacity-light-opacity cursor-default"
                        : "flex bg-primary-nav-act "
                    }`}
                  >
                    <TopNavSmallButton
                      btnText={
                        <>
                          {globalText.LINKED_OWNER}
                          <br />
                          {globalText.ACCOUNT}
                        </>
                      }
                      icon={ICONS?.LINKED_WHITE_CIRCLE}
                      hoverOption={"white"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      handleFunction={() => {
                        if (isInternalAccountDetailModal) {
                          actionRestricted();
                          return;
                        }
                        if (owneraccountId) {
                          navigate(
                            `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${owneraccountId}`,
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "VAccount",
                            },
                          });
                        }
                      }}
                      isDisabled={isInternalAccountDetailModal}
                    />

                    <div className="border-r border-solid border-primary-bg my-margin-sm"></div>

                    <TopNavSmallButton
                      btnText={
                        <>
                          {globalText.ASSOCIATED}
                          <br />
                          {globalText.ACCOUNTS.toLowerCase()}
                        </>
                      }
                      icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                      hoverOption={"white"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      handleFunction={() => {
                        if (isInternalAccountDetailModal) {
                          actionRestricted();
                        } else {
                          openAssociatedAccountsFound();
                        }
                      }}
                      isDisabled={isInternalAccountDetailModal}
                    />
                  </div>
                </div>
                <div className="flex  border-b border-solid border-primary-bg justify-center">
                  <div className="flex py-padding-md w-full">
                    <div className="w-width-md Qmd:pl-padding-sm flex  items-center pr-padding-md gap-y-gap-xs justify-between">
                      <TitleSubtitlePair
                        subtitle="Account number"
                        title={formatAccountNumber(
                          internalAccount?.bank_acc_no,
                        )}
                        titleColor="text-primary"
                        variant="md"
                      />
                      <div className="h-[max-content]">
                        <CommonBankLogo
                          ifsc={internalAccount?.ifsc_code}
                          variant="big"
                          type="pill"
                        />
                      </div>
                    </div>
                    <div className="border-r border-solid border-primary-bg"></div>
                    <div className="flex flex-col w-width-md gap-y-gap-xs px-padding-md whitespace-normal break-words justify-center">
                      <TitleSubtitlePair
                        subtitle="Bank account holder name"
                        title={internalAccount?.bank_account_holder_full_name}
                        titleColor="text-primary"
                        variant="md"
                      />
                    </div>
                  </div>
                  <div
                    className={`flex flex-row-reverse ${
                      isInternalAccountDetailModal
                        ? "bg-primary-nav-act opacity-light-opacity cursor-default"
                        : "bg-primary-nav-act"
                    }`}
                  >
                    <TopNavSmallButton
                      btnText={
                        <>
                          {globalText.EDIT}
                          <br />
                          {globalText.ACCOUNT}
                        </>
                      }
                      icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                      hoverOption={"white"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      handleFunction={() => {
                        if (isArchived || isBlocked) return;
                        if (isInternalAccountDetailModal) {
                          actionRestricted();
                          return;
                        }
                        setEditPopUp(true);
                      }}
                      isDisabled={
                        isInternalAccountDetailModal || isArchived || isBlocked
                      }
                    />
                    <div className="border-r border-solid border-primary-bg my-margin-sm"></div>

                    <TopNavSmallButton
                      btnText={
                        <>
                          {globalText.TRANSACTION}
                          <br />
                          {globalText.HISTORY.toLowerCase()}
                        </>
                      }
                      icon={ICONS?.TRANSACTION_HISTORY}
                      hoverOption={"white"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      handleFunction={() => {
                        if (isInternalAccountDetailModal) {
                          actionRestricted();
                        } else {
                          openTransactionHistory();
                        }
                      }}
                      isDisabled={isInternalAccountDetailModal}
                    />
                  </div>
                </div>
                <div className="flex justify-between">
                  {viewIntData.map((account) => (
                    <>
                      <div
                        className={`flex ${account?.errorMsg ? "" : "w-width-lg"}`}
                      >
                        <div className="w-width-md flex justify-between items-center">
                          <div
                            className={`flex ${account.approval_status === "pending" || account.approval_status === "approved" ? "" : "py-padding-sm"}`}
                          >
                            <div
                              className={`flex flex-col gap-y-gap-xs p-padding-sm ${
                                isInternalAccountDetailModal
                                  ? "cursor-not-allowed opacity-light-opacity"
                                  : "rounded-lg cursor-pointer global-hover-white relative z-z-index-base"
                              }`}
                              onClick={() => {
                                if (
                                  services?.find(
                                    (service) =>
                                      service === "VIFSC" ||
                                      service === "Admin",
                                  ) !== undefined &&
                                  internalAccount?.ifsc_code
                                ) {
                                  if (isInternalAccountDetailModal) {
                                    actionRestricted();
                                  } else {
                                    setIfscShowPopup(true);
                                  }
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VIFSC",
                                    },
                                  });
                                }
                              }}
                            >
                              <div className="flex  justify-between gap-x-gap-sm">
                                <span className="text-font-md text-text-primary font-normal font-sans">
                                  {internalAccount?.ifsc_code}
                                </span>
                                <div className="flex justify-center items-center">
                                  <SVGComponent
                                    color="var(--text-primary)"
                                    url={ICONS?.ARROW_RIGHT_WHITE}
                                    width="var(--icon-sm)"
                                    height="var(--icon-sm)"
                                  />
                                </div>
                              </div>
                              <span className="text-font-xs text-text-secondary font-normal font-sans">
                                IFSC code
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`flex ${
                          account?.errorMsg ? "" : "w-width-sm justify-end"
                        }`}
                      >
                        {viewIntData.map((account) => (
                          <div key={account.id}>
                            {showLoader || showDeclinePopup ? (
                              <div className="w-max-button-width-for-approval-animation flex">
                                <div
                                  className={`w-width-full flex justify-center items-center py-padding-lg ${
                                    clickedBtn === "reject"
                                      ? "bg-negative-act"
                                      : "bg-positive-act"
                                  } `}
                                >
                                  <Loader
                                    height="var(--icon-lg)"
                                    width="var(--icon-lg)"
                                  />
                                </div>
                              </div>
                            ) : account?.approval_status === "approved" ? (
                              <TopNavLargeButton
                                enabledBgColor={"var(--positive-act)"}
                                isDisabled={
                                  !(
                                    services.includes("CInternalTxn") ||
                                    services.includes("Admin")
                                  )
                                }
                                btnText={
                                  <>
                                    {globalText.INITIATE_INTERNAL}
                                    <br />
                                    {globalText.TRANSACTION.toLowerCase()}
                                  </>
                                }
                                icon={ICONS?.INITIATE_INTERNAL_TRANSACTION}
                                hoverOption={"black"}
                                enabledTextColor={"var(--text-primary)"}
                                handleFunction={() => {
                                  if (
                                    !(
                                      services.includes("CInternalTxn") ||
                                      services.includes("Admin")
                                    ) &&
                                    isInternalAccountDetailModal
                                  ) {
                                    return;
                                  } else if (
                                    services?.some(
                                      (service) =>
                                        service === "CInternalTxn" ||
                                        service === "Admin",
                                    ) ||
                                    payload.openTransHistory
                                  ) {
                                    setIsAlertPopup(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "CInternalTxn",
                                      },
                                    });
                                  }
                                }}
                              />
                            ) : account?.approval_status === "rejected" &&
                              errorStrip.length >
                                GlobalConfiguration?.lengthCheckZero ? (
                              <div
                                key={account.id}
                                className="flex justify-end w-[var(--category-popup-height)] h-full"
                              >
                                <div className="flex  gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm py-padding-button-l">
                                  <div className="flex place-items-center">
                                    <div className="flex place-items-center">
                                      <img
                                        src={
                                          ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                        }
                                        className="w-icon-lg h-icon-lg"
                                        alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                      />
                                    </div>
                                  </div>
                                  <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                    <span className="font-semibold font-sans text-font-sm text-text-primary">
                                      Failed to take action
                                    </span>
                                    <span className="text-font-xs text-text-primary errorMsg break-words">
                                      {errorStrip ||
                                        "An error occurred while taking action on this account"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : account.approval_status === "pending" &&
                              errorStrip.length >
                                GlobalConfiguration?.lengthCheckZero ? (
                              <div
                                key={account.id}
                                className="flex justify-end w-[var(--category-popup-height)] h-full"
                              >
                                <div className="flex  gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm py-padding-button-l">
                                  <div className="flex place-items-center">
                                    <div className="flex place-items-center">
                                      <img
                                        src={
                                          ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                        }
                                        className="w-icon-lg h-icon-lg"
                                        alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                      />
                                    </div>
                                  </div>
                                  <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                    <span className="font-semibold font-sans text-font-sm text-text-primary">
                                      Failed to take action
                                    </span>

                                    <span className="text-font-xs text-text-primary errorMsg break-words">
                                      {errorStrip ||
                                        "An error occurred while taking action on this account"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : account.approval_status === "error" ||
                              errorStrip.length >
                                GlobalConfiguration?.lengthCheckZero ? (
                              <div
                                key={account.id}
                                className="flex justify-end w-[var(--category-popup-height)] h-full"
                              >
                                <div className="flex gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm py-padding-button-l">
                                  <div className="flex place-items-center">
                                    <div className="flex place-items-center">
                                      <img
                                        src={
                                          ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                        }
                                        className="w-icon-lg h-icon-lg"
                                        alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                      />
                                    </div>
                                  </div>
                                  <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                    <span className="font-semibold font-sans text-font-sm text-text-primary">
                                      Failed to take action
                                    </span>

                                    <span className="text-font-xs text-text-primary errorMsg break-words">
                                      {errorStrip ||
                                        "An error occurred while taking action on this account"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : account.approval_status === "pending" ? (
                              <div className="w-full flex  justify-end">
                                <TopNavSmallButton
                                  enabledBgColor={"var(--negative-act)"}
                                  btnText={
                                    <>
                                      {globalText.REJECT}
                                      <br />
                                      {globalText.ACCOUNT}
                                    </>
                                  }
                                  icon={
                                    ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE
                                  }
                                  hoverOption={"black"}
                                  enabledTextColor={"var(--text-primary)"}
                                  isDisabled={
                                    !services?.some(
                                      (service) =>
                                        service === "IAAccount" ||
                                        service === "Admin",
                                    )
                                  }
                                  handleFunction={() => {
                                    if (
                                      services?.some(
                                        (service) =>
                                          service === "IAAccount" ||
                                          service === "Admin",
                                      )
                                    ) {
                                      handleDeclinedDetials(
                                        internalAccount?.id,
                                      );
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "IAAccount",
                                        },
                                      });
                                    }
                                  }}
                                />

                                <TopNavSmallButton
                                  enabledBgColor={"var(--positive-act)"}
                                  btnText={
                                    <>
                                      {globalText.APPROVE}
                                      <br />
                                      {globalText.ACCOUNT}
                                    </>
                                  }
                                  icon={ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK}
                                  hoverOption={"black"}
                                  enabledTextColor={"var(--text-primary)"}
                                  isDisabled={
                                    !services?.some(
                                      (service) =>
                                        service === "IAAccount" ||
                                        service === "Admin",
                                    )
                                  }
                                  handleFunction={() => {
                                    if (
                                      services?.some(
                                        (service) =>
                                          service === "IAAccount" ||
                                          service === "Admin",
                                      )
                                    ) {
                                      setClickedBtn("approve");
                                      handleApprovalDetails(
                                        internalAccount?.id,
                                      );
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "IAAccount",
                                        },
                                      });
                                    }
                                  }}
                                />
                              </div>
                            ) : null}
                          </div>
                        ))}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex flex-col bg-primary-card Qlg:hidden">
              <div className="flex flex-col border-b border-solid border-primary-bg p-padding-button-l lg:pt-padding-base gap-y-gap-xs mx-margin-md Qlg:mx-margin-base px-padding-base">
                <p className="text-font-sm text-text-primary font-normal font-sans">
                  {internalAccount?.name?.trim()}
                </p>
                <p className="text-font-xs text-text-secondary font-normal font-sans">
                  Account name
                </p>
              </div>
              {viewIntData?.map((account) => (
                <div className="flex flex-col border-b border-solid border-primary-bg p-padding-button-l gap-y-gap-xs mx-margin-md Qlg:mx-margin-base px-padding-base">
                  <p
                    className={`text-font-sm font-semibold font-sans capitalize ${
                      account.approval_status === "pending" ||
                      account.approval_status === "error"
                        ? "text-pending"
                        : account.approval_status === "approved"
                          ? "text-awaiting"
                          : account.approval_status === "rejected" ||
                              account.approval_status === "blocked"
                            ? "text-failed"
                            : "text-abandoned"
                    }`}
                  >
                    {services?.includes("IAAccount") &&
                    account?.approval_status === "pending"
                      ? "Require approval"
                      : account?.approval_status || "N/A"}
                  </p>
                  <p className="text-font-xs text-text-secondary font-normal font-sans">
                    Account status
                  </p>
                </div>
              ))}
              <div className="flex flex-col border-b border-solid border-primary-bg p-padding-button-l gap-y-gap-xs mx-margin-md Qlg:mx-margin-base px-padding-base">
                <div className="flex  justify-between items-center">
                  <div>
                    <p className="text-font-sm text-text-primary font-normal font-sans">
                      {formatAccountNumber(internalAccount?.bank_acc_no)}
                    </p>
                    <p className="text-font-xs text-text-secondary font-normal font-sans">
                      Account number
                    </p>
                  </div>
                  <div className="h-[max-content]">
                    <CommonBankLogo
                      ifsc={internalAccount?.ifsc_code}
                      variant="big"
                      type="pill"
                    />
                  </div>
                </div>
              </div>
              <div className="flex border-b border-solid border-primary-bg p-padding-button-l gap-x-gap-xs justify-between items-center mx-margin-md Qlg:mx-margin-base px-padding-base">
                <div className="">
                  <p className="text-font-sm text-text-primary font-normal font-sans">
                    {internalAccount?.bank_account_holder_full_name}
                  </p>
                  <p className="text-font-xs text-text-secondary font-normal font-sans">
                    Bank account holder name
                  </p>
                </div>
              </div>
              <div className="flex justify-between items-center Qlg:border-b border-solid border-primary-bg Qlg:pl-padding-sm py-padding-sm mx-margin-sm  Qlg:mx-margin-base px-padding-base">
                <div
                  className={`flex items-center w-width-full justify-between gap-y-gap-xs px-padding-xs ${
                    isInternalAccountDetailModal
                      ? "cursor-not-allowed opacity-light-opacity"
                      : "rounded-lg cursor-pointer"
                  }`}
                  onClick={() => {
                    if (
                      services?.find(
                        (service) => service === "VIFSC" || service === "Admin",
                      ) !== undefined &&
                      internalAccount?.ifsc_code
                    ) {
                      if (isInternalAccountDetailModal) {
                        actionRestricted();
                      } else {
                        setIfscShowPopup(true);
                      }
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "VIFSC",
                        },
                      });
                    }
                  }}
                >
                  <TitleSubtitlePair
                    title={internalAccount?.ifsc_code}
                    subtitle="IFSC code"
                    titleColor="text-primary"
                    variant="md"
                    showArrow
                    hoverOption="white"
                    isDisabled={isInternalAccountDetailModal}
                  />
                </div>
              </div>

              {viewIntData.map((account) => (
                <div
                  className="view in data"
                  key={account.id}
                >
                  {showLoader || showDeclinePopup ? (
                    <>
                      <div className="flex">
                        <div className="w-max-button-width-for-approval-animation flex flex-grow">
                          <div
                            className={`w-width-full flex justify-center items-center py-padding-lg ${
                              clickedBtn === "reject"
                                ? "bg-negative-act"
                                : "bg-positive-act"
                            } `}
                          >
                            <Loader
                              height="var(--icon-lg)"
                              width="var(--icon-lg)"
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ) : account?.approval_status === "approved" ? (
                    <>
                      <div className="flex ">
                        <TopNavLargeButton
                          enabledBgColor={"var(--positive-act)"}
                          isDisabled={
                            !(
                              services.includes("CInternalTxn") ||
                              services.includes("Admin")
                            )
                          }
                          btnText={"Initiate internal transaction"}
                          icon={ICONS?.INITIATE_INTERNAL_TRANSACTION}
                          hoverOption={"black"}
                          fullWidthRequired={true}
                          enabledTextColor={"var(--text-primary)"}
                          handleFunction={() => {
                            if (
                              !(
                                services.includes("CInternalTxn") ||
                                services.includes("Admin")
                              ) &&
                              isInternalAccountDetailModal
                            ) {
                              return;
                            } else if (
                              services?.find(
                                (service) =>
                                  service === "CInternalTxn" ||
                                  service === "Admin",
                              ) !== undefined
                            ) {
                              setIsAlertPopup(true);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "CInternalTxn",
                                },
                              });
                            }
                          }}
                        />
                      </div>
                    </>
                  ) : account?.approval_status === "rejected" &&
                    errorStrip.length > GlobalConfiguration?.lengthCheckZero ? (
                    <div className="flex bg-negative-card">
                      <div className="flex h-full w-full bg-failed-to-take-action py-padding-md px-padding-lg">
                        <div className="flex place-items-center">
                          <img
                            src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                            className="w-icon-lg h-icon-lg flex-shrink-0"
                            alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                          />
                        </div>
                        <div className="flex flex-col gap-y-gap-xs ml-margin-sm">
                          <span className="text-font-sm text-text-primary font-sans font-semibold">
                            Failed to take action
                          </span>
                          <span className="text-font-xxs text-text-primary font-normal font-sans text-wrap">
                            {errorStrip ||
                              "An error occurred while taking action on this account."}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : account.approval_status === "pending" &&
                    errorStrip.length > GlobalConfiguration?.lengthCheckZero ? (
                    <div className="flex bg-negative-card">
                      <div className="flex h-full w-full bg-failed-to-take-action py-padding-md px-padding-lg">
                        <div className="flex place-items-center">
                          <img
                            src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                            className="w-icon-lg h-icon-lg flex-shrink-0"
                            alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                          />
                        </div>
                        <div className="flex flex-col gap-y-gap-xs ml-margin-sm">
                          <span className="text-font-sm text-text-primary font-sans font-semibold">
                            Failed to take action
                          </span>
                          <span className="text-font-xs text-text-primary font-normal font-sans text-wrap">
                            {errorStrip || "An error occurred"}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : account.approval_status === "error" ||
                    errorStrip.length > GlobalConfiguration?.lengthCheckZero ? (
                    <div className="flex bg-negative-card">
                      <div className="flex  h-full w-full bg-failed-to-take-action py-padding-md px-padding-lg">
                        <div className="flex place-items-center">
                          <img
                            src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                            className="w-icon-lg h-icon-lg flex-shrink-0"
                            alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                          />
                        </div>
                        <div className="flex flex-col gap-y-gap-xs ml-margin-sm">
                          <span className="text-font-sm text-text-primary font-sans font-semibold">
                            Failed to take action
                          </span>
                          <span className="text-font-xs text-text-primary font-normal font-sans text-wrap">
                            {errorStrip || "An error occurred"}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : account.approval_status === "pending" ? (
                    <div className="flex ">
                      <div className="flex  w-full">
                        <TopNavSmallButton
                          enabledBgColor={"var(--negative-act)"}
                          btnText={
                            <>
                              {globalText.REJECT}
                              <br />
                              {globalText.ACCOUNT}
                            </>
                          }
                          isDisabled={
                            !services?.some(
                              (service) =>
                                service === "IAAccount" || service === "Admin",
                            )
                          }
                          icon={ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE}
                          hoverOption={"black"}
                          fullWidthRequired={true}
                          enabledTextColor={"var(--text-primary)"}
                          handleFunction={() => {
                            if (
                              services?.find(
                                (service) =>
                                  service === "IAAccount" ||
                                  service === "Admin",
                              ) !== undefined
                            ) {
                              handleDeclinedDetials(internalAccount?.id);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "IAAccount",
                                },
                              });
                            }
                          }}
                        />
                        <TopNavSmallButton
                          enabledBgColor={"var(--positive-act)"}
                          btnText={
                            <>
                              {globalText.APPROVE}
                              <br />
                              {globalText.ACCOUNT}
                            </>
                          }
                          icon={ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK}
                          hoverOption={"black"}
                          fullWidthRequired={true}
                          enabledTextColor={"var(--text-primary)"}
                          isDisabled={
                            !services?.some(
                              (service) =>
                                service === "IAAccount" || service === "Admin",
                            )
                          }
                          handleFunction={() => {
                            if (
                              services?.find(
                                (service) =>
                                  service === "IAAccount" ||
                                  service === "Admin",
                              ) !== undefined
                            ) {
                              setClickedBtn("approve");
                              handleApprovalDetails(internalAccount?.id);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "IAAccount",
                                },
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
            <div className="block mt-margin-md Qlg:hidden">
              <CommonQuickActionButtons
                title="Quick Actions"
                actions={[
                  {
                    key: "linked-owner",
                    btnText: (
                      <>
                        {globalText.VIEW_LINKED}
                        <br />
                        {globalText.OWNER_ACCOUNT}
                      </>
                    ),
                    icon: ICONS.LINKED_WHITE_CIRCLE,
                    isDisabled: isInternalAccountDetailModal,
                    handleFunction: () => {
                      if (isInternalAccountDetailModal) {
                        return actionRestricted();
                      }

                      if (owneraccountId) {
                        navigate(
                          `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${owneraccountId}`,
                        );
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "VAccount",
                          },
                        });
                      }
                    },
                  },
                  {
                    key: "associated",
                    btnText: (
                      <>
                        {globalText.ASSOCIATED}
                        <br />
                        {globalText.ACCOUNTS.toLowerCase()} {globalText.FOUND}
                      </>
                    ),
                    icon: ICONS.ASSSOCIATED_ACCOUNTS_FOUND,
                    isDisabled: isInternalAccountDetailModal,
                    handleFunction: () => {
                      if (isInternalAccountDetailModal) {
                        return actionRestricted();
                      }

                      openAssociatedAccountsFound();
                    },
                  },
                  {
                    key: "history",
                    btnText: (
                      <>
                        {globalText.TRANSACTION}
                        <br />
                        {globalText.HISTORY.toLowerCase()}
                      </>
                    ),
                    icon: ICONS.TRANSACTION_HISTORY,
                    isDisabled: isInternalAccountDetailModal,
                    handleFunction: () => {
                      if (isInternalAccountDetailModal) {
                        return actionRestricted();
                      }
                      openTransactionHistory();
                    },
                  },
                  {
                    key: "edit",
                    btnText: (
                      <>
                        {globalText.EDIT}
                        <br />
                        {globalText.ACCOUNT.toLowerCase()}
                      </>
                    ),
                    icon: ICONS.EDIT_WITH_WHITE_CIRCLE,
                    isDisabled:
                      isInternalAccountDetailModal || isArchived || isBlocked,
                    handleFunction: () => {
                      if (isArchived || isBlocked) return;

                      if (isInternalAccountDetailModal) {
                        actionRestricted();
                        return;
                      }
                      setEditPopUp(true);
                    },
                  },
                ]}
              />
            </div>
            {internalAccount?.approval_status === "pending" && (
              <div className=" w-full bg-primary-card ">
                <div className=" w-full lg:w-max-content-width m-auto">
                  <CommonAlertsStrip alerts={buildAlerts()} />
                </div>
              </div>
            )}
            <div
              className={`flex-grow w-full bg-primary-bg secondaryDetailsblock ${
                isInternalAccountDetailModal
                  ? "pb-padding-xl"
                  : editPopUp
                    ? ""
                    : "pb-padding-md"
              }`}
            >
              <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto">
                <div className="detail-category-button w-full flex Qmd:pt-padding-md pb-padding-md lg:mx-auto ml-margin-md mt-margin-md Qsmd:mt-margin-base">
                  <SwitcherTabs
                    initialActiveTab={
                      labelDetailTab
                        ? "Labels"
                        : additionalRecipient
                          ? "Recipients"
                          : ""
                    }
                    tabs={[
                      {
                        label: "Details",
                        key: "details",
                        handler: toggleDetails,
                      },
                      {
                        label: "Labels",
                        key: "labels",
                        handler: toggleLabelDetails,
                      },
                      {
                        label: "Recipients",
                        key: "recipients",
                        handler: toggleAdditionalRecipicent,
                      },
                    ]}
                    setIndex={setIndex}
                  />
                </div>
                <div className="relative overflow-hidden px-padding-md lg:px-padding-base">
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      <div className="flex flex-col gap-y-gap-md justify-evenly Qlg:flex-row  Qlg:gap-x-gap-md">
                        <CommonDetailCard
                          variant="fourth"
                          numCols={GlobalConfiguration?.lengthCheckOne}
                          cardTitle="Contact Details"
                          entries={[
                            {
                              heading: "Contact number",
                              content: internalAccount?.contact_no
                                ? `+91 ${internalAccount?.contact_no}`
                                : "Not given",
                              type: "text",
                            },
                            {
                              heading: "Email ID",
                              content: internalAccount?.email_id || "Not given",
                              type: "text",
                            },
                          ]}
                        />
                        <CommonDetailCard
                          variant="fourth"
                          numCols={GlobalConfiguration?.lengthCheckOne}
                          cardTitle="Account Details"
                          entries={[
                            {
                              heading: "PAN number",
                              content: internalAccount?.pan_no || "Not given",
                              type: "text",
                              onClick: internalAccount?.pan_no
                                ? () => {
                                    if (
                                      services?.find(
                                        (service) =>
                                          service === "VPAN" ||
                                          service === "Admin",
                                      ) !== undefined &&
                                      internalAccount?.pan_no
                                    ) {
                                      if (isInternalAccountDetailModal) {
                                        actionRestricted();
                                      } else {
                                        setPanShowPopup(true);
                                      }
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "VPAN",
                                        },
                                      });
                                    }
                                  }
                                : undefined,
                              isDisabled: isInternalAccountDetailModal,
                            },
                            {
                              isDisabled: isInternalAccountDetailModal,
                              heading: "GST number",
                              content:
                                internalAccount?.gstin_detail || "Not given",
                              type: "text",
                              onClick: internalAccount?.gstin_detail
                                ? () => {
                                    if (isInternalAccountDetailModal) {
                                      actionRestricted();
                                    } else {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "VGSTIN" ||
                                            service === "Admin",
                                        ) !== undefined
                                      ) {
                                        setGstShowPopup(true);
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VGSTIN",
                                          },
                                        });
                                      }
                                    }
                                  }
                                : undefined,
                            },
                          ]}
                        />
                        <CommonDetailCard
                          variant="fourth"
                          numCols={GlobalConfiguration?.lengthCheckOne}
                          cardTitle="Origin Details"
                          entries={approvalEntry}
                        />

                        <CommonDetailCard
                          variant="fourth"
                          numCols={GlobalConfiguration?.lengthCheckOne}
                          cardTitle="Support Information"
                          entries={[
                            {
                              heading: "Account ID",
                              content: internalAccount?.id,
                              type: "text",
                            },
                            {
                              heading: "Account type",
                              content: "Internal account",
                              type: "text",
                            },
                          ]}
                        />
                      </div>
                    </div>
                  )}
                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header="Labels"
                        subheader="Labels will be used to generate statistics for the
                      associated accounts."
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (isInternalAccountDetailModal) {
                            actionRestricted();
                          } else {
                            handleClick();
                          }
                        }}
                        icon={ICONS?.EDIT}
                        iconIsDisabled={isInternalAccountDetailModal}
                      >
                        <div className="flex flex-wrap w-full gap-gap-sm">
                          {Array.isArray(labelDetails) &&
                          labelDetails.length >
                            GlobalConfiguration?.lengthCheckZero ? (
                            <>
                              {labelDetails.map((item, index) => (
                                <Chips
                                  txtChip={item}
                                  enabledTextColor="var(--text-primary)"
                                  enabledBgColor="var(--primary-nav)"
                                  isTickerRequired={false}
                                />
                              ))}
                            </>
                          ) : (
                            <p className="text-font-sm text-text-primary">
                              Not assigned labels.
                            </p>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}
                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header={globalText?.ADDITIONAL_RECIPIENTS}
                        subheader=" The email IDs provided below will be used to send updates
                      and notifications to the selected individuals."
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (isInternalAccountDetailModal) {
                            actionRestricted();
                            return;
                          } else if (
                            isArchived ||
                            isBlocked ||
                            !services?.find(
                              (service) => service === "IUAccount",
                            )
                          ) {
                            return;
                          } else {
                            setShowAdditionalSection(true);
                            setAdditionalChip(showAdditionalRecipient);
                          }
                        }}
                        icon={ICONS?.EDIT}
                        iconIsDisabled={
                          isArchived ||
                          isBlocked ||
                          !services?.find(
                            (service) => service === "IUAccount",
                          ) ||
                          isInternalAccountDetailModal
                        }
                      >
                        <div className="flex flex-wrap w-full gap-gap-sm">
                          {Array.isArray(showAdditionalRecipient) &&
                          showAdditionalRecipient.length >
                            GlobalConfiguration?.lengthCheckZero ? (
                            <>
                              {showAdditionalRecipient.map((item) => (
                                <div
                                  key={item}
                                  className="px-padding-button-l py-padding-button-m flex rounded-border-radius-md bg-primary-nav max-w-full"
                                >
                                  <div className="text-text-primary text-font-xs inline-block break-all">
                                    {linkIdentifier(item)}
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : (
                            <span className="text-text-primary text-sm">
                              Not given.
                            </span>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InternalAccountDetails;
